import React, { Fragment, useState } from 'react';
import styled from 'styled-components';
import { Formik, FieldArray, Field } from 'formik';
import {
  RenderTextField,
  RenderSelect,
} from '../../../../../../components/FormElements/FormikElements';
import { Button } from 'merchant-portal-components';
import { Modal } from 'merchant-portal-components';
import ConfirmOverridesModal from '../../../../Products/ProductWizard/components/ConfirmOverridesModal';
import ConfirmCancelModal from '../../../../Products/ProductWizard/components/ConfirmCancelModal';
import getExistingLocations from '../../../../utils/getExistingLocations';

const ModalTitle = styled.div`
  display: grid;
  grid-template-columns: 10fr 1fr;
  padding: 24px;
`;

const ButtonsWrapper = styled.div`
  padding: 20px 40px;
  box-shadow: 0 -2px 9px 0 rgba(0, 0, 0, 0.12);
  display: grid;
  grid-template-columns: 3fr 1fr;
`;

const ModalBody = styled.div`
  padding: 0 24px;

  overflow-y: scroll;
  height: 60vh;
`;

const ButtonDiv = styled(Button)`
  width: 100px;
  min-width: 100px;
`;

const Title = styled.p`
  color: #191818;
  font-size: 17px;
  font-weight: 600;
  margin: 23px 0;
`;

const VariantsDiv = styled.div`
  margin-top: 40px;
`;

const HeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 30px;
`;

const Header = styled.p`
  font-size: 15px;
  font-weight: 600;
`;

const BodyDiv = styled.div``;

const RowWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-top: 10px;
`;

const RowCol = styled.div`
  font-size: 14px;
  align-self: center;
`;

const NoLocationSelectedDiv = styled.p`
  color: #959595;
  font-size: 20px;
  letter-spacing: 0.03;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
`;

const ComboOverridesModal = ({
  isOverrideModal,
  setIsOverrideModal,
  formattedBusinesses,
  combo,
  comboId,
  summaryData,
  handleSubmitComboOverrides,
  isCreate,
  disabled,
  isConfirmModal,
  setIsConfirmModal,
  isConfirmOverridesModal,
  setIsConfirmOverridesModal,
  selectedLocations,
  setSelectedLocations,
}) => {
  const handleConfirmButtonClick = () => {
    if (
      (isOverrideModal.price && isOverrideModal.assignedBusinesses.length) ||
      (!isOverrideModal.price && !isOverrideModal.assignedBusinesses.length)
    ) {
      setIsConfirmModal(false);
      setIsOverrideModal({
        isShowing: false,
        price: null,
        assignedBusinesses: [],
      });
    } else {
      setIsConfirmModal(false);
      setIsOverrideModal({
        ...isOverrideModal,
        assignedBusinesses: [],
      });
    }
  };

  return (
    <Modal borderRadius>
      <div
        style={{
          width: '550px',
        }}
      >
        <ModalTitle>
          <div>Overrides</div>
          <div
            onClick={() =>
              setIsOverrideModal({
                isShowing: false,
                price: null,
                assignedBusinesses: [],
              })
            }
            style={{ cursor: 'pointer' }}
          >
            x
          </div>
        </ModalTitle>

        <Formik
          initialValues={{
            assignedBusinesses: isOverrideModal.assignedBusinesses.map(
              (business) => business.id
            ),
            price: isOverrideModal.price || combo.fixed_price,
          }}
          enableReinitialize={true}
        >
          {({
            dirty,
            values,
            setFieldValue,
            initialValues,
            handleChange,
            touched,
          }) => (
            <Fragment>
              <ModalBody>
                <Title>Select a Location</Title>
                <Field
                  name="assignedBusinesses"
                  component={RenderSelect}
                  options={formattedBusinesses || []}
                  isMulti
                  setFieldValue={setFieldValue}
                  getOptionLabel={(business) =>
                    business.isDisabled
                      ? `${business.business_name} - Business is not associated`
                      : business.business_name
                  }
                  getOptionValue={(business) => business.id}
                  valueKey="id"
                  placeholder="Search Locations"
                  onChange={(e) => {
                    setSelectedLocations(e);
                  }}
                  simpleValue
                />

                {!selectedLocations.length ? (
                  <NoLocationSelectedDiv>
                    Select a location to add overrides
                  </NoLocationSelectedDiv>
                ) : (
                  <VariantsDiv>
                    <HeaderWrapper>
                      <Header>Combo</Header>
                      <Header>Price</Header>
                    </HeaderWrapper>

                    <FieldArray
                      name="price"
                      render={(arrayHelpers) => {
                        return (
                          <Fragment>
                            <BodyDiv>
                              <div>
                                <RowWrapper>
                                  <RowCol>Overriden Price</RowCol>
                                  <RowCol style={{ paddingRight: '20px' }}>
                                    <Field
                                      id="price"
                                      name="price"
                                      component={RenderTextField}
                                      isPrice
                                      placeholder={`${initialValues.price}`}
                                      {...(isCreate ? { value: null } : {})}
                                    />
                                  </RowCol>
                                </RowWrapper>
                              </div>
                            </BodyDiv>
                          </Fragment>
                        );
                      }}
                    />
                  </VariantsDiv>
                )}
              </ModalBody>
              <ButtonsWrapper>
                <ButtonDiv
                  secondary
                  onClick={() => {
                    if (dirty) setIsConfirmModal(true);
                    else {
                      if (
                        (isOverrideModal.price &&
                          isOverrideModal.assignedBusinesses.length) ||
                        (!isOverrideModal.price &&
                          !isOverrideModal.assignedBusinesses.length)
                      ) {
                        setIsOverrideModal({
                          isShowing: false,
                          price: null,
                          assignedBusinesses: [],
                        });
                      } else
                        setIsOverrideModal({
                          ...isOverrideModal,
                          assignedBusinesses: [],
                        });
                    }
                  }}
                >
                  {isOverrideModal.assignedBusinesses.length &&
                  !isOverrideModal.price
                    ? 'Back'
                    : 'Cancel'}
                </ButtonDiv>
                <ButtonDiv
                  onClick={() => {
                    if (
                      !isCreate &&
                      isOverrideModal.initialBusinesses.length <
                        values.assignedBusinesses.length
                    ) {
                      setIsConfirmOverridesModal(true);
                    } else {
                      // setIsOverrideModal({
                      //   isShowing: false,
                      //   price: null,
                      //   assignedBusinesses: [],
                      // });
                      handleSubmitComboOverrides(
                        comboId,
                        summaryData,
                        values,
                        isCreate,
                        isOverrideModal.initialBusinesses,
                        isOverrideModal.index,
                        initialValues,
                        touched,
                        () =>
                          setIsOverrideModal({
                            isShowing: false,
                            price: null,
                            assignedBusinesses: [],
                          })
                      );
                    }
                  }}
                  disabled={!dirty}
                >
                  Save
                </ButtonDiv>
              </ButtonsWrapper>

              {isConfirmModal && (
                <ConfirmCancelModal
                  onCancel={() => {
                    setIsConfirmModal(false);
                  }}
                  onConfirm={() => {
                    handleConfirmButtonClick();
                  }}
                />
              )}

              {isConfirmOverridesModal && (
                <ConfirmOverridesModal
                  businesses={getExistingLocations(
                    selectedLocations,
                    summaryData,
                    initialValues
                  )}
                  onCancel={() => setIsConfirmOverridesModal(false)}
                  onConfirm={() => {
                    handleSubmitComboOverrides(
                      comboId,
                      summaryData,
                      values,
                      isCreate,
                      isOverrideModal.initialBusinesses,
                      isOverrideModal.index,
                      isCreate,
                      touched,
                      () =>
                        setIsOverrideModal({
                          isShowing: false,
                          prices: null,
                          assignedBusinesses: [],
                        })
                    );
                  }}
                />
              )}
            </Fragment>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default ComboOverridesModal;
